import ParentalControl from "./ParentalControl";

export default ParentalControl;
